import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Institution } from 'src/types/institution';
import { getSmallestImageUrl } from 'src/utils/image';

export function DailyQuotaProviders({ data }: { data?: Institution[] }) {
  return (
    <Box>
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#fff3e8',
          px: 2,
          py: 1,
        }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}>
          <Box
            sx={{
              width: '2px',
              height: '30px',
              backgroundColor: '#ff8210',
            }}
          />
          <Box
            width="100%"
            display="flex"
            flexWrap="wrap"
            flexDirection={{ xs: 'column', md: 'row' }}
            textTransform="uppercase"
            alignItems={{ xs: 'flex-start', md: 'center' }}>
            <Typography component="span">
              Os valores diários são providos por:&nbsp;
            </Typography>
            {data?.map((institution) => (
              <Box
                component={Link}
                to={`/instituicao/${institution.slug}/${institution.id}`}
                key={institution.id}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  textDecoration: 'none',
                }}>
                <Typography
                  fontWeight="bold"
                  textTransform="uppercase"
                  color="secondary">
                  {institution.razaoSocial || institution.fantasyName}
                </Typography>
                {institution.logo && (
                  <Box
                    component={'img'}
                    src={getSmallestImageUrl(institution.logo)}
                    alt={institution.razaoSocial || institution.fantasyName}
                    width={30}
                    height={30}
                    sx={{
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
